import { ReminderTimesConfigurationModel } from '@/modules/settings/pages/alert-reminders/types';
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';

const defaultValues: ReminderTimesConfigurationModel = {
  remindTimeDriverCardReadingAlert: "",
  remindTimeDriverCardExpireAlert: "",
  remindTimeVehicleCardReadingAlert: "",
  remindTimeVehicleCalibrationAlert: "",
  remindTimeInsuranceValidityDateAlert: "",
  remindTimeCheckupDateAlert: "",
  remindTimeUserAlert: "",
  remindTimeDriverDeclarationExpireAlert: "",
  remindTimeDriverLicenceValidToExpireAlert: "",
}

type remindConfigurationName = keyof typeof defaultValues

function parseData(data: Partial<ReminderTimesConfigurationModel>, defaultData: ReminderTimesConfigurationModel = defaultValues) {
  return {
    remindTimeDriverCardReadingAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeDriverCardExpireAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeVehicleCardReadingAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeVehicleCalibrationAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeInsuranceValidityDateAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeCheckupDateAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeUserAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeDriverDeclarationExpireAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
    remindTimeDriverLicenceValidToExpireAlert: String(data?.remindTimeDriverCardReadingAlert || defaultData.remindTimeDriverCardReadingAlert || ""),
  }
}

const parseNextData = (curr: ReminderTimesConfigurationModel, next: ReminderTimesConfigurationModel) : ReminderTimesConfigurationModel => {
  const parsed = { ...defaultValues, ...curr }
  Object.entries(curr).forEach(([name]) => {
    if(next[name] && next[name] !== curr[name]){
      parsed[name] = next[name]
    } else {
      parsed[name] = curr[name]
    }
  })
  return parsed
}

export function useFormAlertReminders(apiData: ReminderTimesConfigurationModel|null) {
  const lastApiDataRef = useRef<ReminderTimesConfigurationModel|null>(null)
  const [draft, setDraft] = useState<ReminderTimesConfigurationModel>(parseData(apiData))

  const handleReset = () => {
    setDraft(draft => parseNextData(draft, apiData))
  }

  useEffect(() => {
    if(apiData && JSON.stringify(lastApiDataRef.current) !== JSON.stringify(apiData)){
      setDraft(draft => parseNextData(draft, apiData))
    }
    lastApiDataRef.current = apiData
  }, [apiData])

  const handleSelect = useCallback((e: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value } = e.target
    if (Object.keys(defaultValues).includes(name)) {
      setDraft(saved => ({ ...saved, [name]: value, }))
    }
  }, [])

  return {
    isDirty: JSON.stringify(lastApiDataRef.current) !== JSON.stringify(draft),
    draft,
    handleSelect,
    handleReset,
  }
}
